module.exports = __webpack_public_path__ + "img/csm__MG_8979_8a386a461a.81cc2a12.jpg";